import { createAppStore } from '@brass-brasil/core';
import '@syncfusion/ej2-base/styles/fluent.css';
import { AxiosRequestConfig } from 'axios';
import { lazy, StrictMode, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.scss';

import { registerLicense } from '@syncfusion/ej2-base';

registerLicense('ORg4AjUWIQA/Gnt2XVhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5QdkdjUHxYcnFTQWNc');


const start = performance.now();

const AppRouter = lazy(() => import('./AppRouter'));

ReactDOM.render(
  <StrictMode>
    <link id="theme-link" rel="stylesheet" href="https://cdn.syncfusion.com/ej2/20.4.38/material.css" />
    <Provider store={createAppStore()}>
      <Suspense
        fallback={
          <div className='k-loading-mask'>
            <span className='k-loading-text'>Loading</span>
            <div className='k-loading-image'></div>
            <div className='k-loading-color'></div>
          </div>
        }
      >
        <AppRouter />
      </Suspense>
    </Provider>
  </StrictMode>,
  document.getElementById('root'),
);
/*

const end = performance.now();
console.log(`Render time: ${end - start}ms`);

const intercept = (config: AxiosRequestConfig<any>) => {
  config.baseURL = process.env.REACT_APP_API_URL || 'http://localhost:8088';
  config.url = config.url.replace('connect/', '');
  return config;
};

window['xintercept'] = intercept;
*/


const end = performance.now();
console.log(`Render time: ${end - start}ms`);

const LOCAL_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8088';

const intercept = (config: AxiosRequestConfig<any>) => {

  if (config.baseURL.includes("/connect")) {
    config.baseURL = config.baseURL.replace('/connect', '');
  }
  if (config.baseURL.includes("/auth")) {
    config.baseURL = config.baseURL.replace('/auth', '');
  }

  if (config.url.includes('//')) {
    //console.log(config.baseURL, config.url);
    //const p = config.url.indexOf('//');
    //config.url = config.url.replace('//', '/');
  }

  if (config.url.includes("v2/communications/list")) {
    // console.log("interceptou communications",);
    // config.baseURL = 'http://localhost:8080';
    // return config;
  }
  if (document.location.href.includes("connect-api")) {
    // config.baseURL = 'http://localhost:8080';
    //  return config;
  }
  if (document.location.href.includes("localhost")) {
    config.baseURL = LOCAL_API_URL;
    config.url = config.url.replace('connect/', '');
  }
  return config;
};

window['xintercept'] = intercept;